// JsFromRoutes CacheKey 845174b3f137ff5f5233e7003c17b298
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  clauseBodyForNego: definePathHelper('get', '(/:admin)/custom_clauses/:id/clause_body_for_nego'),
}
